"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;




























var _user = require("@/utils/user");
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { components: { Tinymce: _Tinymce.default }, data: function data() {return { addData: { id: '', longContent: '' }, searchData: { insId: '' }, rules: { longContent: [{ required: true, message: '请输入企业文化', trigger: 'blur' }] } };}, mounted: function mounted() {var self = this;var orgId = self.$route.query.orgId;if (orgId) {self.searchData.insId = orgId;}
    this.init();
  },
  methods: {
    init: function init() {
      var self = this;
      self.getData('/api/temi/content?itemId=6', self.searchData, function (res) {
        for (var val in res) {
          for (var index in res[val].list) {
            var obj = res[val].list[index];
            self.addData.longContent = obj.longContent;
            self.addData.id = obj.id;
          }
        }
      });
    },
    checkPermission: _user.checkPermission,
    onSubmit: function onSubmit() {// 新增提交操作
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          // 组装上传数据
          var uploadData = new Array(0);
          uploadData.push({ 'id': self.addData.id, 'itemId': 6, 'longContent': self.addData.longContent, 'isEnable': 1 });
          self.postData('/api/temi/content', uploadData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

          });
        } else {
          return false;
        }
      });
    } } };exports.default = _default;